import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Content, DropdownStyle } from './dropdown-style';

function Dropdown(props) {
  const { content, placement, title, action, children, style, className, open, onOpenChange } = props;

  return (
    <DropdownStyle
      overlayClassName={className}
      style={style}
      placement={placement}
      title={title}
      overlay={<Content>{content}</Content>}
      trigger={action}
      open={open}
      onOpenChange={onOpenChange}
    >
      {children}
    </DropdownStyle>
  );
}

const content = (
  <>
    <Link to="#">
      <span>Export to CSV</span>
    </Link>
    <Link to="#">
      <span>Export to XML</span>
    </Link>
    <Link to="#">
      <span>Export to Drive</span>
    </Link>
  </>
);

Dropdown.defaultProps = {
  action: ['hover'],
  placement: 'bottomRight',
  content,
  style: {},
  className: 'ninjadash-dropdown',
};

Dropdown.propTypes = {
  placement: PropTypes.string,
  title: PropTypes.string,
  action: PropTypes.array,
  content: PropTypes.node,
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
};

export { Dropdown };
